import type { OpenPosition } from '@flipster/r230522/normal-sub/tables/private/positions';
import type { OpenPosition as LegacyOpenPosition } from '@flipster/r230522/original/position';
import Num, { BigNumber } from '@flipster/utils/num';

export type DisplayedLeverageType = 'positionLeverage' | 'effectiveLeverage';

/** 설정된 표시 타입에 따른 레버리지 표시 문자열 (훅/atom 양쪽에서 쓰는 순수 함수) */
export function formatLeverageDisplay(
  displayedLeverage: DisplayedLeverageType,
  position: Pick<LegacyOpenPosition | OpenPosition, 'initLeverage' | 'effectiveLeverage'> | undefined,
): string {
  if (!position) {
    return '-';
  }

  const { initLeverage, effectiveLeverage } = position;

  switch (displayedLeverage) {
    case 'positionLeverage':
      return String(initLeverage);
    case 'effectiveLeverage':
      if (!effectiveLeverage) return '-';
      return Num(effectiveLeverage).toFixed(1, BigNumber.ROUND_HALF_UP);
    default:
      displayedLeverage satisfies never;
      return '-';
  }
}
